import { createSlice } from "@reduxjs/toolkit";
import { yearBadgeAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const yearBadgeSlice = createSlice({
  name: "yearBadge",
  initialState: data,
  reducers: {
    yearBadgeSlice(state) {
      state.isLoading = false;
    },
    yearBadgeSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    yearBadgeSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    yearBadgeSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const yearBadgeHandler = () => async (dispatch: any) => {
  try {
    dispatch(yearBadgeAction.yearBadgeSlice());
    const response: any = await yearBadgeAPI();
    dispatch(yearBadgeAction.yearBadgeSliceSuccess(response));
  } catch (e: any) {
    dispatch(yearBadgeAction.yearBadgeSliceFailure(e?.response?.data?.message));
    dispatch(yearBadgeAction.yearBadgeSliceReset());
  }
};
export default yearBadgeSlice.reducer;
export const yearBadgeAction = yearBadgeSlice.actions;
